import React from 'react'
// import { Switch, withStyles } from "@material-ui/core";
// import { purple } from "@material-ui/core/colors";
import './Header.css'
const Header = ({lightMode}) => {
  // const [lightMode, setlightMode] = useState(false);
  // const DarkMode = withStyles({
  //   switchBase: {
  //     color: purple[300],
  //     '&$checked': {
  //       color: purple[500],
  //     },
  //     '&$checked + $track': {
  //       backgroundColor: purple[500],
  //     },
  //   },
  //   checked: {},
  //   track: {},
  // })(Switch);

    return (
        <span onClick={() => window.scroll(0, 0)} className="header" 
        style={{
          // height: "100vh",
          backgroundColor: lightMode ?'#39445a' : 'rebeccapurple',
          color: lightMode ? "gold": "white",
          transition: "all 0.5s linear",
        }}
        >
        <img  style={{borderRadius:100 , height:70 , marginTop:20 ,marginRight :10}} src ="favicon.ico" alt=""/>
      
         Unknown Coder 🎥
        {/* <div style={{position: 'absolute', top: 0, right: 15, paddingTop: 10}}>
          <DarkMode  checked={lightMode}  onChange={() => setlightMode(!lightMode)}/>
          </div> */}
      </span> 
    )
}

export default Header
